import { render, staticRenderFns } from "./FloatWidget.vue?vue&type=template&id=12623657&"
import script from "./FloatWidget.vue?vue&type=script&lang=js&"
export * from "./FloatWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports